<template>
  <div class="personnelSelection">
    <!-- 自定义触发内容 -->
    <div v-if="custom" style="width: inherit" ref="customRef">
      <slot name="custom" />
    </div>
    <div v-else style="width: inherit">
      <!-- 默认触发内容 -->
      <el-select-v2
        style="width: 100%"
        v-model="showValue"
        ref="selectRef"
        :options="options"
        :collapse-tags-tooltip="options.length <= 10"
        multiple
        popper-class="personnelSelection"
        :collapse-tags="collapseTags"
        @focus="visibleChange"
        @remove-tag="removeTag"
        v-bind="$attrs"
        :disabled="props.disabled"
        :placeholder="placeholder"
      >
        <!-- <el-option
        v-for="(item, index) in personelTree.data"
        :key="index"
        :label="item.realName"
        :disabled="item.disable"
        :value="item.id"
      /> -->
      </el-select-v2>
    </div>
    <el-popover
      :visible="custom ? innerVisible : undefined"
      :virtual-ref="virtualRef"
      ref="popoverRef"
      trigger="click"
      title=""
      :disabled="disabled"
      popper-class="personnelSelectionPopper"
      width="740"
      :placement="placement"
      destroy-on-close
      :popper-options="{
        modifiers: [{ enabled: true }],
        strategy: 'fixed',
        placement: 'auto'
      }"
      virtual-triggering
      @show="show"
    >
      <SelectPanel
        :isWorkbench="$attrs.isWorkbench"
        @registerPanel="registerPanel"
        @close="close"
        @update="update"
        @confirm="confirm"
      >
        <template #dynamic>
          <slot name="dynamic" />
        </template>
      </SelectPanel>
    </el-popover>
  </div>
</template>

<script lang="ts" setup>
import { ref, unref, reactive, computed, onMounted, watch, nextTick } from 'vue'
import SelectPanel from './selectPanel.vue'
import type { BasicProps, UserVOList } from './type'
import { usePanel } from './hooks/usePanel'
import { isFunc } from '@/utils/is'
const emit = defineEmits(['update:visible', 'update:value', 'sure', 'getUserList'])
const personelTree = reactive<any>({
  data: []
})
const options = computed(() => {
  return personelTree.data.map((item: Recordable) => {
    return {
      label: item.realName,
      value: item.id,
      disabled: item.disable
    }
  })
})

const popoverRef = ref()
const selectRef = ref()
const customRef = ref()
const virtualRef = ref()
const showPanel = ref<boolean>(false)
const showValue = ref<string[]>([])
const showTag = ref<string[]>([])
const loadNum = ref<number>(0)
let innerVisible = computed({
  get: () => props.visible,
  set: (visible: boolean) => emit('update:visible', visible)
})
const props = withDefaults(defineProps<BasicProps>(), {
  custom: false,
  visible: false,
  activeName: 'members',
  paramsData: {},
  placeholder: '请选择',
  placement: 'bottom',
  collapseTags: true,
  disabled: false,
  isRoleVisible: true,
  menuId: ''
})

watch(
  () => props.visible,
  val => {
    if (val) {
      visibleChange()
    } else {
      close()
    }
  }
)

watch(
  () => props.value,
  val => {
    showValue.value = val
    if (props.custom) {
      innerVisible.value = props.visible
    }
  }
)

// watch(() => props.showValueData, (val) => {
// })

const [
  registerPanel,
  {
    init,
    updateValue,
    getCheckedUser,
    getContainChildren,
    getParameter,
    getSaveDefault,
    getSelectedShow,
    reload,
    handleCheckedValue
  }
] = usePanel()
watch(
  () => props,
  () => {
    // console.log(props, '组件已渲染AA', loadNum.value, props.visible)
    if (!props.disabled) {
      virtualRef.value = props.custom ? customRef.value : selectRef.value
    } else {
      unref(popoverRef)?.hide?.()
      virtualRef.value = ''
    }

    const fn = () => {
      nextTick(() => {
        init(unref(props))
        loadNum.value++
      })
    }
    const shouldCallFn =
      (props.showValueData && props.showValueData.length > 0) || props.data || props.visible

    if (loadNum.value === 0 && shouldCallFn) {
      fn()
    } else if (props.data && !props.api) {
      fn()
    } else {
      handleCheckedValue(props.showValueData || [])
    }
  },
  {
    deep: true,
    immediate: true
  }
)

async function visibleChange() {
  console.log(loadNum.value, 'loadNum.value')
  selectRef.value?.blur?.()
  showPanel.value = true
  if (props.visibleBeforeFn && isFunc(props.visibleBeforeFn)) {
    const flag = await props.visibleBeforeFn()
    if (!flag) {
      close()
    }
  } else {
    if (loadNum.value === 0) {
      init(props)
      loadNum.value++
    } else {
      setTimeout(() => {
        reload(props)
      }, 30)
    }
  }
  unref(popoverRef) && unref(popoverRef).popperRef?.delayHide?.()
}

function close() {
  if (props.custom) {
    innerVisible.value = false
  } else {
    unref(popoverRef).hide?.()
  }
  selectRef?.value?.blur?.()
  showPanel.value = false
}

function getData() {
  return {
    userInfoList: getCheckedUser(),
    saveDefult: getSaveDefault(),
    dynamicParameters: getParameter(),
    selectedShow: getSelectedShow(),
    containChildren: getContainChildren()
  }
}

function update(data: UserVOList[]) {
  personelTree.data = (data || []).slice(0, 20)
  const ids = data.map(item => item.id) || []
  showValue.value = [...ids]
  showTag.value = [...ids].slice(0, 20)
  emit('getUserList', data)
}

function confirm() {
  personelTree.data = (getCheckedUser() || []).slice(0, 20)
  showValue.value = getCheckedUser().map((item: Recordable) => item.id)
  emit('sure', getData())
  emit('update:value', showValue.value)
  close()
}

function removeTag(tagValue: any) {
  const newValue = getCheckedUser().filter((item: Recordable) => item.id !== tagValue)
  updateValue(newValue, 'clear')
  emit('sure', getData())
}

onMounted(async () => {
  if (!props.disabled) {
    virtualRef.value = props.custom ? customRef.value : selectRef.value
  }
})

function show() {
  console.log('打开了')
}
</script>

<style lang="scss">
.personnelSelectionPopper {
  padding: 0 !important;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}
.personnelSelection {
  .el-select-dropdown,
  .el-popper__arrow {
    display: none !important;
  }
}
</style>
